const firstValue = (...values) => values.find((value) => value !== undefined && value !== null && value !== "") || "";

const datePart = (value) => {
  if (!value) return "";
  const text = String(value);
  return text.includes("T") ? text.split("T")[0] : "";
};

const timePart = (value) => {
  if (!value) return "";
  const match = String(value).match(/T(\d{2}:\d{2})/);
  return match?.[1] || "";
};

export const roomCodeFor = (room = {}) => firstValue(
  room.meetingId,
  room.meeting_id,
  room.roomCode,
  room.room_code,
  room.meetingCode,
  room.meeting_code,
  room.code
);

export const isDeletedOnlineClass = (room = {}) => {
  const status = String(room.status || "").toLowerCase();
  return room.deleted === true
    || room.isDeleted === true
    || Boolean(room.deletedAt || room.deleted_at)
    || status === "deleted";
};

export const normalizeOnlineClass = (room = {}) => {
  const scheduledStart = firstValue(
    room.scheduledStart,
    room.scheduled_start,
    room.scheduledAt,
    room.scheduled_at,
    room.startAt,
    room.start_at
  );
  const scheduledEnd = firstValue(
    room.scheduledEnd,
    room.scheduled_end,
    room.scheduledEndAt,
    room.scheduled_end_at,
    room.endAt,
    room.end_at
  );

  return {
    ...room,
    id: firstValue(room.id, room.roomId, room.room_id),
    meetingId: roomCodeFor(room),
    topic: firstValue(room.topic, room.title, room.className, "Scheduled class"),
    teacherName: firstValue(room.teacherName, room.teacher_name, room.hostName, "Assigned faculty"),
    scheduledDate: firstValue(room.scheduledDate, room.scheduled_date, room.date, datePart(scheduledStart)),
    startTime: firstValue(room.startTime, room.start_time, timePart(scheduledStart)),
    endTime: firstValue(room.endTime, room.end_time, timePart(scheduledEnd)),
    status: String(room.status || "scheduled").toLowerCase(),
    deleted: isDeletedOnlineClass(room),
  };
};

export const normalizeVisibleOnlineClasses = (rooms = []) => (
  (Array.isArray(rooms) ? rooms : [])
    .map(normalizeOnlineClass)
    .filter((room) => !room.deleted)
);
